export const LIST_BULK_SMS_START = 'LIST_BULK_SMS_START';
export const LIST_BULK_SMS_SUCCESS = 'LIST_BULK_SMS_SUCCESS';
export const LIST_BULK_SMS_ERROR = 'LIST_BULK_SMS_ERROR';
